/* eslint-disable import/no-anonymous-default-export */
import MapOutlined from "@mui/icons-material/MapOutlined";
import LocalActivityOutlinedIcon from "@mui/icons-material/LocalActivityOutlined";
import LocalTaxiOutlinedIcon from "@mui/icons-material/LocalTaxiOutlined";
import DvrOutlinedIcon from "@mui/icons-material/DvrOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

export default [
  {
    name: "مسیرها",
    path: "/paths",
    icon: MapOutlined,
    children: [
      {
        name: "پروژه",
        path: "/addresses",
        icon: MapOutlined,
      },
      {
        name: "سرویس ها",
        path: "/survey",
        icon: MapOutlined,
      },
    ],
  },
  {
    name: "بلیط ها",
    path: "/tickets/enable",
    icon: DvrOutlinedIcon,
  },
  // {
  //   name: "تاریخچه سفارشات",
  //   path: "/tickets",
  //   icon: LocalActivityOutlinedIcon,
  // },

  {
    name: "دربستی",
    path: "/hiring",
    icon: LocalTaxiOutlinedIcon,
  },
  {
    name: "سبد خرید",
    path: "/cart",
    icon: ShoppingCartOutlinedIcon,
  },
];
